import React, { useMemo } from "react";
import clxs from "./cluster-villa-banner.module.css";
import useClx from "../../../../hooks/use-clx";
import { Track } from "../../../AnalyticsManager";
import PLAY_ICON from "../../../../assets/icons/play-icon.svg";
import Img from "../../../Img";
import createResponsiveSrc from "../../../../../utils/create-responsive-src";

interface ClusterVillaBannerProps {
  className?: string;
  villa: ClusterPropertyImages;
}

function ClusterVillaBanner(props: ClusterVillaBannerProps) {
  const { className, villa } = props,
    ccx = useClx(clxs.container, className);

    const MOBILE_WIDTH = 1024,
    DESKTOP_WIDTH = 1200, // or 1440, if your layout allows
    ASPECT_RATIO = 4 / 3,
    MOBILE_HEIGHT = Math.round(MOBILE_WIDTH / ASPECT_RATIO),
    DESKTOP_HEIGHT = Math.round(DESKTOP_WIDTH / ASPECT_RATIO),
    { first_image_mobile_url, first_image_desktop_url, first_image_alt, first_image_caption } = useMemo(() => {
      if(villa.images && villa.images.length) {
        const { url, alt, caption } = villa.images[0];
        const {mobile : improved_mobile_url,desktop: improved_desktop_url} = createResponsiveSrc(url,75,50,[DESKTOP_WIDTH, DESKTOP_HEIGHT],[MOBILE_WIDTH, MOBILE_HEIGHT]);
        return { first_image_mobile_url:improved_mobile_url, first_image_desktop_url:improved_desktop_url, first_image_alt: alt, first_image_caption: caption };
      }
      return { first_image_mobile_url: "", first_image_desktop_url: "", first_image_alt: "", first_image_caption: "" };
    },[villa.images]);

  return (
    <div className={ccx}>
      <div className={clxs.bannerContainer}>
        <div className={clxs.villaCard}>
          <Img
            alt={first_image_alt || villa.villa_name}
            title={first_image_caption || undefined}
            mobileSrc={first_image_mobile_url}
            desktopSrc={first_image_desktop_url}
            src={first_image_desktop_url}
            loading="eager"
            fetchpriority="high"
            className={clxs.imgSelect}
          />
          <div className={clxs.villaBadge}>{villa.villa_name}</div>
          <div className={clxs.villaActions}>
            {villa.videos.length > 0 && (
              <div className={clxs.videoButtonWrapper}>
                <button className={clxs.videoButton}>
                  <div className={clxs.playIcon}>
                    <img
                      src={PLAY_ICON}
                      alt="Play"
                      className={clxs.playIconImage}
                    />
                  </div>
                  <span>View Video</span>
                </button>
              </div>
            )}

            <Track event="property_detail_view_photos_clicked">
            <div className={clxs.photoStackWrapper}>
              {Array.from({ length: 2 }, (_, index) => (
                <div
                  key={index}
                  className={clxs.smallImage}
                >
                  <div className={clxs.morePhotosOverlay}>
                    {index === 0 && (
                      <div className={clxs.overlayText}>
                        <span>+ {villa.images?.length - 1 || 0}</span>
                        <span>more</span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            </Track>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClusterVillaBanner;

